import { InfoModalVersion } from "@redotech/redo-model/team";
import { TnplContractTemplateInAutoCheck } from "@redotech/redo-model/tnpl-contract-template";
import { InfoModalSettingsValue } from "@redotech/redo-model/widget";
import { convertUndefinedIfDefault } from "@redotech/util/object";
import { DeepPartial } from "@redotech/util/type";
import cloneDeepWith from "lodash/cloneDeepWith";
import merge from "lodash/merge";
import { replaceContractVariables } from "./try-first-button-config";

// Default values
export const titleSubtitleDefault = { titleText: "", subtitleText: "" };

export const infoModalEmptyDefaults: InfoModalSettingsValue = {
  cartIconEnabled: true,
  checkoutIconEnabled: true,
  enableTopLayerModalApi: false,
  logo: "",
  sideImage: "",
  version: InfoModalVersion.V2,
  headerText: "",
  subheaderText: "",
  line1: titleSubtitleDefault,
  line2: titleSubtitleDefault,
  line3: titleSubtitleDefault,
  customCss: "",
};

export const defaultTryFirstInfoModal: InfoModalSettingsValue = {
  cartIconEnabled: true,
  checkoutIconEnabled: true,
  enableTopLayerModalApi: false,
  logo: "",
  sideImage: "",
  version: InfoModalVersion.V2,
  headerText: "Try before you buy",
  subheaderText:
    "Shop with confidence, knowing you can return what you don't like.",
  line1: {
    titleText: "Try at home for %trialLength% days after delivery",
    subtitleText:
      "After delivery, you have %trialLength% days to try out your item to make sure it's exactly what you love.",
  },
  line2: {
    titleText: "Easily return what you don't love",
    subtitleText:
      "Choose the items that you want to keep, and send the rest back to us!",
  },
  line3: {
    titleText: "Only pay for what you keep",
    subtitleText:
      "You will pay for the items that you keep and be refunded for what you don't want.",
  },
  customCss: "",
};

export const getEvaluatedInfoModalSettings = ({
  settingsTemplate,
  contractTemplate,
}: {
  settingsTemplate: DeepPartial<InfoModalSettingsValue>;
  contractTemplate?: TnplContractTemplateInAutoCheck;
}): InfoModalSettingsValue => {
  const inputUndefinedIfDefault = convertUndefinedIfDefault(settingsTemplate, [
    infoModalEmptyDefaults,
  ]);
  const settingsWithDefaults = merge(
    {},
    defaultTryFirstInfoModal,
    inputUndefinedIfDefault,
  );

  const evaluatedSettings = cloneDeepWith(
    settingsWithDefaults,
    (value: any): any => {
      const replacedValue = replaceContractVariables(value, contractTemplate);
      if (replacedValue !== value) {
        return replacedValue;
      }
      // Returning undefined will clone as normal
    },
  );

  return evaluatedSettings;
};
